import React, { useState } from 'react';
import EdenredButtons from '@pages/DesignSystem/button/EdenredButton';
import Edenredmodal from '../index';

const ModelFour = () => {
	const [isOpen, setisOpen] = useState(false);
	return (
		<>
			<EdenredButtons
				{...{
					btnType: 'primary',
					onClick: () => setisOpen(true),
					style: { marginTop: '20px' },
				}}>
				Modal With One Button And Secondary button
			</EdenredButtons>
			<Edenredmodal
				{...{
					title: 'Do You Want To Continue?',
					desc: 'Edenred',
					onCancelButton: 'save',
					onCancel: () => setisOpen(false),
					isOpen: isOpen,
					close: () => setisOpen(false),
					secondarybtn: 'Secondary CTA',
					center: true,
					textcenter: true,
				}}
			/>
		</>
	);
};

export default ModelFour;
